import React, { memo, useCallback } from "react";
import { Card, Input, Controller, Button, SelectBox } from "components/src";
import { useTranslation } from "react-i18next";
import { FormProvider, useForm } from "react-hook-form";
import { Form, Switch } from "antd";
import { useGetAuthorityFindRoles, usePostAdminAddNewUser } from "core";

const NAMEANDFAMILY = "nameAndFamily";
const USERNAME = "userName";
const PASSWORD = "password";
const ROLE = "role";
const MOBILENUMBER = "mobileNumber";
const ISACTIVE = "isActive";

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 16 },
};

const EditMandantoryMemberShip = memo(() => {
  // const { i18n } = useTranslation();

  // const methods = useForm({
  //   defaultValues: {
  //     nameAndFamily: "",
  //     userName: "",
  //     password: "",
  //     role: "",
  //     mobileNumber: "",
  //     isActive: false,
  //   },
  // });

  // const { data, isFetching } = useGetAuthorityFindRoles({pageSize:"20",pageNumber:"1"});

  // console.log({ data });

  // const rolesItem = data?.map((item: { name: string }) => {
  //   return {
  //     value: item.name,
  //     label: item.name,
  //   };
  // });

  // const { handleSubmit, reset } = methods;

  // const onSubmit = useCallback(
  //   ({
  //     nameAndFamily,
  //     userName,
  //     password,
  //     role,
  //     mobileNumber,
  //     isActive,
  //   }: {
  //     nameAndFamily: string;
  //     userName: string;
  //     password: string;
  //     mobileNumber: any;
  //     role: string;
  //     isActive: boolean;
  //   }) => {
  //     mutate({
  //       requestBody: {
  //         nameAndFamily: nameAndFamily,
  //         userName: userName,
  //         password: password,
  //         role: [role],
  //         mobileNumber: mobileNumber,
  //         isActive: isActive,
  //         group: "",
  //       },
  //     });
  //   },
  //   []
  // );

  // const { mutate, isPending } = usePostAdminAddNewUser({
  //   onSuccess: () => {
  //     reset();
  //   },
  // });

  return (<></>
    // <>
    //   <Card title={i18n.t("EditUser")}>
    //     <FormProvider {...methods}>
    //       <Form
    //         {...layout}
    //         name="nest-messages"
    //         onFinish={handleSubmit(onSubmit)}
    //       >
    //         <Form.Item>
    //           <Controller name={NAMEANDFAMILY}>
    //             <Input placeholder={i18n.t("nameAndFamily")} />
    //           </Controller>
    //         </Form.Item>

    //         <Form.Item>
    //           <Controller name={USERNAME}>
    //             <Input placeholder={i18n.t("userName")} />
    //           </Controller>
    //         </Form.Item>

    //         <Form.Item>
    //           <Controller name={PASSWORD}>
    //             <Input placeholder={i18n.t("password")} />
    //           </Controller>
    //         </Form.Item>

    //         <Form.Item>
    //           <Controller name={ROLE}>
    //             <SelectBox aria-multiselectable label={i18n.t("role")} options={rolesItem} />
    //           </Controller>
    //         </Form.Item>

    //         <Form.Item>
    //           <Controller name={MOBILENUMBER}>
    //             <Input placeholder={i18n.t("mobileNumber")} />
    //           </Controller>
    //         </Form.Item>

    //         <Form.Item label={i18n.t("status")}>
    //           <Controller name={ISACTIVE}>
    //             <Switch />
    //           </Controller>
    //         </Form.Item>

    //         <Form.Item wrapperCol={{ ...layout.wrapperCol, offset: 5 }}>
    //           <Button
    //             style={{ width: "100px" }}
    //             type="primary"
    //             isLoading={isPending}
    //             htmlType="submit"
    //           >
    //             {i18n.t("done")}
    //           </Button>
    //         </Form.Item>
    //       </Form>
    //     </FormProvider>
    //   </Card>
    // </>
  );
});
export { EditMandantoryMemberShip };
